import { render, staticRenderFns } from "./PartnerPrograms.vue?vue&type=template&id=0f161630&scoped=true&"
import script from "./PartnerPrograms.vue?vue&type=script&lang=js&"
export * from "./PartnerPrograms.vue?vue&type=script&lang=js&"
import style0 from "./PartnerPrograms.vue?vue&type=style&index=0&id=0f161630&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f161630",
  null
  
)

export default component.exports